import { useState } from "react";
import { useHandleInputChange } from "../hooks/useHandleInputChange";
import { useModal } from "../hooks/useModal";
import { _zzsurvey_ajax } from "../utils/zz/zz-zzsurvey-ajax-adapter";
import { _zzsurvey_utils_backendQuizBlueprint_to_quizBlueprint } from "../utils/zz/zz-zzsurvey-quiz-utils";
import { _zzsurvey_formDefiinitionCustomerRegisterPublic, _zzsurvey_formDefiinitionCustomer_v2 } from "../utils/zz/zz-zzsurvey-utils";
import Btn from "./Btn";
import FormGenerator from "./FormGenerator";
import FormFieldGenerator from "./FormFieldGenerator";
import SpinnerClassic from "./SpinnerClassic";
import { browser_utils } from "../utils/frfr-browser-utils";


//
const _create_quiz_fill_url = (quiz_key) => {
  const origin = window.location.origin; // "http://localhost:3000"
  const url = origin + '/survey/' + quiz_key;
  // https://dev.ratemyservice.rs/survey/67e49b2f-4ba2-4d48-b7aa-333fe94fa844
  return url;
};


// DEFAULT COMPONENT
const ZZTempSurveyPublicPageFillSurveyStepRegisterCustomer = (props) => {
  console.log('ZZTempSurveyPublicPageFillSurveyStepRegisterCustomer', ' props', props);
  const { dispatchShowToast } = useModal();
  const {
    // appState,
    quiz_key,
    detected_env,
    token_from_qr_template, // NNN
  } = props;
  // console.log('appState.url_path', appState.url_path);
  // console.log('appState.quiz_key', appState.quiz_key);
  // const quiz_key = appState.quiz_key;
  console.log('quiz_key', quiz_key);
  console.log('token_from_qr_template', token_from_qr_template);


  ////
  //
  const error_msg_handle = (err) => {
    let error_msg = 'Error!';
    if (typeof err?.response?.data?.message === 'string') {
      error_msg = err.response.data.message;
    }
    /*
    if (err?.response?.data?.error === "jwt expired") {
        error_msg = 'You must login again!';
    } else {
        console.log(err?.response?.data?.error);
      console.log(err?.response?.data?.error?.type);
      if (err?.response?.data?.error?.type === "field") {
        error_msg = err.response.data.error.msg;
      } else {
        if (typeof err?.response?.data?.message === 'string') {
        error_msg = err.response.data.message;
        } else {
          if (err?.response?.status === 404) {
        error_msg = '404 API route not found';
          }
        }
      }
    }
      */
    dispatchShowToast(error_msg, 'RED');
  };
  //
  const [fetching, setFetching] = useState(false);
  const [state, handleChange, setState] = useHandleInputChange({ phone: '' }); // state of register user form
  //
  const handleClickSubmitCustomerRegisterPublic = (e) => { // TODO
    if (true) {
      // STEP 1 spinner
      // setFetchingSubmit(true);
      setFetching(true);
      // STEP 2 fetching
      /*
      let _prepared_entity = {
        ...entity,
        client_id: seller_selected_client_id
      };
      */
      let _prepared_entity = {
        // ...entity,
        // client_id: seller_selected_client_id
        ...state,
        // token: tokenFromTemplateURL
        token: token_from_qr_template
      };
      const phone_prefix = '+3816';
      _prepared_entity.phone = phone_prefix + state.phone;
      _zzsurvey_ajax.registerCustomer(_prepared_entity)
        .then(response => {
          console.log('registerCustomer response', response);
          // STEP 3 fetched
          // setFetchingSubmit(false);
          // setModalPortableContent(false);
          // fetchListUniversal(view_key);
          //
          //
          /*
          3) Pravi se zahtev za kreiranje SurveyInstance.
          
          Kada kupac submituje podatke o sebi (ako je submit bio uspesan), odmah napraviti zahtev na novu rutu CreateSurveyInstance, ona je javna - POST /api/v1/surveys/instance.
          U telu je potrebno proslediti token (u istom obliku kako ga je frontend dobio prvobitno), kao i customer_id (dobija se kao odgovor prethodnog koraka). Ova ruta u odgovoru vraca
          UUID novokreirane survey instance.
          */
          /*
          if (response?.data?.customer?.customer_id) { // validate quick
            {
                "message": "Successfully registered customer.",
                "customer": {
                    "customer_id": 12,
                    "is_anonymous": false,
                    "name": "direkt1",
                    "email": "direkt1@direkt1.com",
                    "cdp_sifra": null,
                    "phone": null,
                    "location": null,
                    "date_created": "2025-07-14T10:28:14.000Z",
                    "date_updated": "2025-07-14T10:28:14.000Z",
                    "created_by": null,
                    "last_updated_by": null,
                    "client": {
                        "client_id": 1,
                        "name": "AK KOMPRESOR NISSAN",
                        "email": "jasmina.vojinovic@akkompresor.rs",
                        "phone": "+381658148181",
                        "logo": null,
                        "is_active": true,
                        "api_key": "AIzaSyD3lcpyU2ZrQpcix7z0lW2hahvg1jUVfHw",
                        "place_id": "ChIJv1uCxxl7WkcRXZDijRN5yf0"
                    }
                }
            }
          */
          if (response?.data?.customer?.qr_customer_id) { // validate quick
            /*
            {
                "message": "Successfully registered QR customer.",
                "customer": {
                    "qr_customer_id": 17,
                    "phone": "+381691119991",
                    "client": {
                        "client_id": 1,
                        "name": "AK KOMPRESOR NISSAN",
                        "email": "jasmina.vojinovic@akkompresor.rs",
                        "phone": "+381658148181",
                        "logo": null,
                        "is_active": true,
                        "api_key": "AIzaSyD3lcpyU2ZrQpcix7z0lW2hahvg1jUVfHw",
                        "place_id": "ChIJv1uCxxl7WkcRXZDijRN5yf0"
                    }
                }
            }
            */
            console.log('*** response?.data?.customer', response?.data?.customer);
            // const customer_id = response.data.customer.customer_id;
            const customer_id = response.data.customer.qr_customer_id;
            const qr_customer_id = response.data.customer.qr_customer_id;
            //
            //
            // ---STEP create instance
            const _instance_without_email_entbox = {
              // survey_template_id: entity.survey_template_id,
              customer_id,
              qr_customer_id,
              // token: tokenFromTemplateURL
              token: token_from_qr_template
            };
            _zzsurvey_ajax.createSurveyInstance(_instance_without_email_entbox)
              .then(response => {
                console.log('createSurveyInstance response', response);
                // TODO nema pokazatelja da je uspašan update
                /*
                setFetchingSubmit(false);
                setAppState(appState => {
                  return {
                    ...appState,
                    seller_selected_multiple_ccustomer_ids: [], // RESET TODO
                  };
                });
                setModalPortableContent(false);
                fetchListUniversal(view_key);
                */
                if (response?.data?.survey?.survey_instance_id) { // validate quick
                  const survey_instance_id = response.data.survey.survey_instance_id;
                  const quiz_key = survey_instance_id;
                  const qr_url = _create_quiz_fill_url(quiz_key);
                  // setUrlForQuizFillWithoutEmail(qr_url);
                  //
                  // REDIRECT
                  const url = qr_url;
                  browser_utils.browser_go_url(url);
                }
              })
              .catch(err => {
                // STEP 3b FAIL
                console.log('CATCH error after axios', err);
                error_msg_handle(err);
                // setFetchingSubmit(false);
              })
            //
            //
          } else {

          }
          setFetching(false);
        })
        .catch(err => {
          // STEP 3b FAIL
          console.log('CATCH error after axios', err);
          error_msg_handle(err);
          // setFetchingSubmit(false);
          setFetching(false);
        })

    }
  };

  //
  let jsxRegisterCustomer = (
    <>
      <div className="zzsurvey__sign-form__limiter">
        {/*<h1>Fill survey</h1>*/}
        <h1>Anketa za kupce</h1>
        {/*<h3>Step 1) Enter your data</h3>*/}

        <div className="zz-novo-form-simple">
          {/*
          <FormGenerator
            formDefinition={_zzsurvey_formDefiinitionCustomerRegisterPublic}
            formState={state}
            formErrors={{}}
            handleChange={handleChange}
          />
          */}
          <div className="zzsurvey__form-with-phone-prefix">
            <div className="zzsurvey__form-with-phone-prefix__prefix">+3816</div>
            <FormFieldGenerator
              fieldDefinition={{
                "type": "input_text",
                "params": {
                  // "label": "phone",
                  "label": "Broj telefona",
                  "name": "phone",
                  // "w": 320
                }
              }}
              value={state.phone}
              handleChange={handleChange}
            />
          </div>
          <div className="xi">
            <Btn
              title_OLD='Next step'
              title='Započni anketu'
              btnDialogSubmit
              handleClick={handleClickSubmitCustomerRegisterPublic}
              disabled={false}
            />
          </div>
        </div>
      </div>
    </>
  );


  ////
  ////
  ////


  /*
  useEffect(() => {
    console.log('useEffect quiz_key');
    browser_utils.browser_title_set('RateMyService portal - We want to hear from you');
    if (quiz_key) {
      fetchQuizBlueprint(quiz_key);
    } else {
      console.log('ERROR IN URL PATH');
      setState({
        ...state,
        // quiz_key: null,
        fetching: false,
        error: 'ERROR There is no survey with that key! Check URL.'
      });
    }
  }, [quiz_key]);
  */


  let jsxSpinner = null;
  if (fetching === true) {
    jsxSpinner = (
      <div className="zzsurvey__bar-vector-with-spinner"><SpinnerClassic inlineSmall /> <b>Please wait...</b> <span>(fetching customer register)</span></div>
    );
  }


  // render
  return (
    <div className="zzsurvey__layout-page-wrapper zzsurvey__layout-page-wrapper--public this-is-quiz-fill-page">
      {
        detected_env === 'DEV' && (
          <div className="zzsurvey-app__env">DEV ENVIRONMENT</div>
        )
      }
      {
        detected_env === 'STG' && (
          <div className="zzsurvey-app__env">STG ENVIRONMENT FOR TESTING</div>
        )
      }
      {
        fetching === false ? (
          <>
            <div class="zzsurvey__quiz__bg-wrapper">
              <div class="zzsurvey__quiz__panel">
                <div class="zzsurvey__quiz__header">
                  {jsxRegisterCustomer}
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="flex-1"></div>
            <div className="zzsurvey__landing-content">
              <div>{jsxSpinner}</div>
            </div>
            <div className="flex-2"></div>
          </>
        )
      }
    </div>
  );
};

export default ZZTempSurveyPublicPageFillSurveyStepRegisterCustomer;